<template>
  <div>
    <div class="widget-wrap">
      <div class="deal_sidebar block-header clearfix">
        <div class="pull-left">
          <p>事項分析</p>
        </div>
        <div class="pull-right">
          <small class="pointer" @click="helpActivitiesResourceModal=true">關於事項分析？</small>
        </div>
      </div> 
      <div class="widget-container">
        <div class="widget-content">
          <div class="row">
            <div class="col-md-12 deal_page_sidebar_content">
              <table class="table table-bordered">
                <tr>
                  <th class="text-center">事項類型</th>
                  <th class="text-center">數量</th>
                  <th class="text-center">所用時數</th>
                </tr>
                <tr v-for="category in activity_categories">
                  <td class="text-center"><i v-bind:class="category.icon"></i> {{category.title}}</td>
                  <td class="text-center">{{countActivitiesNumber(category.id)}}</td>
                  <td class="text-center">{{countFinishedHour(category.id)}}</td>
                </tr>
                <tr>
                  <td class="text-center">未分類</td>
                  <td class="text-center">{{countActivitiesNumber(null)}}</td>
                  <td class="text-center">{{countFinishedHour(null)}}</td>
                </tr>
              </table>
              <h4>總時數：{{totalHours()}}</h4>
              <small class="text-gray">此處的總數只包含了有定義小時的事項，所以只標示日期的事項（沒有小時）沒有辦法列入計算～</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="helpActivitiesResourceModal" @keyup.esc="helpActivitiesResourceModal=false;">
      <div class="modal-mask">
        <div class="modal-wrapper " @click="helpActivitiesResourceModal=false;">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <div class="widget-header margin-bottom-0 clearfix">
                  <h4>事項分析 也是資源管理</h4>
                </div>
              </div>
              <a href="#" class="btn-close" @click="helpActivitiesResourceModal=false;">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms text-left">
              <h5>介紹：</h5>
              <p style="padding-left:20px;">分析有關於此專案，或是此業務在這段時間內的所有<span class="text-info">完成的</span>待辦事項。依照類別統計總數，以及所使用的時間</p>
              <h5>優點：</h5>
              <p style="padding-left:20px;">事項分析就是資源管理！可以馬上了解此案件或業務，總共花在此專案上的時數。更快速的評估使用的時間資源，是否值得此專案，或是哪個環節出了問題，更方便於專案的管理</p>
              <h5>如何確實的呈現數據？</h5>
              <p style="padding-left:20px;">將所有待辦事項，都確實定義所用的時間（小時與分），Flowneat將會自動計算完成的事項所使用的時間，若只是圈出日期的代辦事項，將不會列入計算。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>
<script>
import { getCookie } from '../../assets/js/elffy_js/cookie.js'
import moment from 'moment';
export default {
  name: 'ActivitiesResource',
  data() {
    return {
      helpActivitiesResourceModal:false,
    }
  },
  created() {
    moment.locale('zh-tw');
  },
  props: ['activities','activity_categories'],
  computed: {
    
  },
  methods: {
    countActivitiesNumber(category_id){
      var all = this.activities.filter(function(a){
        return a.activity_category_id == category_id && a.content_type == 'event'
      })

      var finished = all.filter(function(a){
        return a.activity_status == "finish"
      })
      var result = finished.length + '/' + all.length

      return result
    },
    countFinishedHour(category_id){
      var total_minutes = 0
      var finished_activities = this.activities.filter(function(a){
        return a.activity_category_id == category_id &&
               a.activity_status == 'finish' &&
               a.allDay == false
               a.content_type == 'event'
      })
      $.each(finished_activities,function(key,activity){
        //取得分鐘數
        var time = (new Date(activity.end) - new Date(activity.start))/60000
        total_minutes += time
      })
      var hour = Math.floor(total_minutes/60)
      var minutes = total_minutes%60
      var result = '無'
      if(hour==0 && minutes == 0){
        result = '無'
      }else if(hour==0 && minutes != 0){
        result = minutes+'分'  
      }else{
        result = hour+"小時,"+minutes+'分'
      }
      return result
    },
    totalHours(){
      let vm = this
      var total_minutes = 0
      var finished_activities = this.activities.filter(function(a){
        return a.activity_status == 'finish' &&
               a.allDay == false
               a.content_type == 'event'
      })
      $.each(finished_activities,function(key,activity){
        //取得分鐘數
        var time = (new Date(activity.end) - new Date(activity.start))/60000
        total_minutes += time
      })
      var hour = Math.floor(total_minutes/60)
      var minutes = total_minutes%60
      var result = '無'
      if(hour==0 && minutes == 0){
        result = '0小時'
      }else if(hour==0 && minutes != 0){
        result = minutes+'分'  
      }else{
        result = hour+"小時,"+minutes+'分'
      }
      return result
    }
  }
}
</script>


// WEBPACK FOOTER //
// ActivitiesResource.vue?25d87d01